import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=2e22c034"
import script from "./Recipient.vue?vue&type=script&lang=js"
export * from "./Recipient.vue?vue&type=script&lang=js"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=2e22c034&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports